const BASE = "https://gufgaff.com/api";

export const getMovies = (params = {}) =>
  fetch(`${BASE}/movies?${new URLSearchParams(params)}`).then(r => r.json());

export const getTrending = () =>
  fetch(`${BASE}/movies/trending`).then(r => r.json());

export const getMovie = (id) =>
  fetch(`${BASE}/movies/${id}`).then(r => r.json());

export const searchMovies = (q) =>
  fetch(`${BASE}/movies?search=${q}`).then(r => r.json());

export const searchAll = (q) =>
  fetch(`${BASE}/movies/search?q=${encodeURIComponent(q)}`).then(r => r.json());

export const submitRating = (movie_id, rating_key, token) =>
  fetch(`${BASE}/ratings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ movie_id, rating_key }),
  }).then(r => r.json());

export const getDiscussions = (params = {}, token = null) =>
  fetch(`${BASE}/discussions?${new URLSearchParams(params)}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then(r => r.json());

export const createDiscussion = (data, token) =>
  fetch(`${BASE}/discussions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data),
  }).then(r => r.json());

export const voteDiscussion = (disc_id, side, token) =>
  fetch(`${BASE}/discussions/${disc_id}/vote`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ side }),
  }).then(r => r.json());

export const deleteDiscussion = (disc_id, token) =>
  fetch(`${BASE}/discussions/${disc_id}`, {
    method: "DELETE",
    headers: { "Authorization": `Bearer ${token}` },
  }).then(r => r.json());

export const postReply = (disc_id, body, token) =>
  fetch(`${BASE}/discussions/${disc_id}/replies`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify({ body }),
  }).then(r => r.json());

export const getWatchProviders = (movie_id) =>
  fetch(`${BASE}/movies/${movie_id}/watch-providers`).then(r => r.json());

export const getShows = (params = {}) =>
  fetch(`${BASE}/shows?${new URLSearchParams(params)}`).then(r => r.json());

export const getShow = (id) =>
  fetch(`${BASE}/shows/${id}`).then(r => r.json());

export const getShowWatchProviders = (show_id) =>
  fetch(`${BASE}/shows/${show_id}/watch-providers`).then(r => r.json());

export const submitShowRating = (show_id, rating_key, token) =>
  fetch(`${BASE}/show-ratings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ show_id, rating_key }),
  }).then(r => r.json());

export const login = (loginField, password) =>
  fetch(`${BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ login: loginField, password }),
  }).then(r => r.json());

export const checkAvailability = (data) =>
  fetch(`${BASE}/auth/check-availability`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(r => r.json());

export const register = (username, email, password, location) =>
  fetch(`${BASE}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, email, password, location }),
  }).then(r => r.json());

export const verifyFirebase = (id_token) =>
  fetch(`${BASE}/auth/verify-firebase`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id_token }),
  }).then(r => r.json());

export const completeRegistration = (data) =>
  fetch(`${BASE}/auth/complete-registration`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(r => r.json());

export const checkUsername = (username) =>
  fetch(`${BASE}/auth/check-username`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username }),
  }).then(r => r.json());

export const getMe = (token) =>
  fetch(`${BASE}/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const getDiscussion = (disc_id) =>
  fetch(`${BASE}/discussions/${disc_id}`).then(r => r.json());

export const editDiscussion = (disc_id, data, token) =>
  fetch(`${BASE}/discussions/${disc_id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(data),
  }).then(r => r.json());

export const editReply = (disc_id, reply_id, body, token) =>
  fetch(`${BASE}/discussions/${disc_id}/replies/${reply_id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ body }),
  }).then(r => r.json());

export const deleteReply = (disc_id, reply_id, token) =>
  fetch(`${BASE}/discussions/${disc_id}/replies/${reply_id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const getUserLists = (token) =>
  fetch(`${BASE}/lists`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const getUserListForMovie = (movie_id, token) =>
  fetch(`${BASE}/lists?movie_id=${movie_id}`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const addToListAPI = (movie_id, list_type, token) =>
  fetch(`${BASE}/lists`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ movie_id, list_type }),
  }).then(r => r.json());

export const removeFromListAPI = (movie_id, list_type, token) =>
  fetch(`${BASE}/lists`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ movie_id, list_type }),
  }).then(r => r.json());

// ─── Admin ─────────────────────────────────────────────────────────────────

export const adminGetUsers = (token) =>
  fetch(`${BASE}/admin/users`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const adminDeleteDiscussion = (disc_id, token) =>
  fetch(`${BASE}/admin/discussions/${disc_id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const adminDeleteReply = (reply_id, token) =>
  fetch(`${BASE}/admin/replies/${reply_id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const adminDeleteUser = (user_id, token) =>
  fetch(`${BASE}/admin/users/${user_id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  }).then(r => r.json());

export const submitFeedback = (data) =>
  fetch(`${BASE}/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(r => r.json());